import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { KeyValueOpt, KeyValue } from '../../../models/keyvalue.model';
import { ButtonSize, ButtonStyle, ButtonType, ButtonColors } from '../../inputs/button/button.model';
import { trigger, transition, style, animate } from '@angular/animations';
import { IQuesComponentInterface } from '../ques.type';
import { QuesResponseType, QuestionCompResponse } from '../ques.model';

@Component({
    selector: 'app-ques-choice-response',
    templateUrl: './ques-choice-response.component.html',
    styleUrls: ['./ques-choice-response.component.scss'],
    standalone: false,
    animations: [
        trigger('fadeIn', [
            transition(':enter', [
                style({ opacity: '0' }),
                animate('1s ease-in', style({ opacity: '1' })),
            ]),
            transition(':leave', [
                style({ opacity: '1' }),
                animate('2s ease-out', style({ opacity: '0' })),
            ])
        ]),
    ]
})
export class QuesChoiceResponseComponent implements OnInit {
  
    ngOnInit() {        
        //This blank function is mandatory.
    }
   
}
